export default "__VITE_PUBLIC_ASSET__89c7960a__"